import { useState, useEffect, ChangeEvent } from "react";
import { Pagination } from "@mui/material";

import "./style.scss";
import { SelectionFilterT } from "../../components/menu-filter/menu-filter.comp";

export const PaginationBlock = ({
    totalCount,
    page,
    setPage,
    perPageList,
    perPage,
    setPerPage,
    showFirstButton = false,
    showLastButton = false,
    hidePrevButton = false,
    hideNextButton = false,
    siblingCount = undefined,
    boundaryCount = undefined
}: {
    totalCount: number;
    page: number;
    setPage: (arg1: number) => void;
    perPageList: number[];
    perPage: number;
    setPerPage: (arg1: number) => void;
    showFirstButton?: boolean;
    showLastButton?: boolean;
    hidePrevButton?: boolean;
    hideNextButton?: boolean;
    siblingCount?: number;
    boundaryCount?: number;
}) => {
    const [pageCount, setPageCount] = useState<number>(Math.ceil(totalCount / perPage));

    const handlePageChange = (_: ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    useEffect(() => {
        setPageCount(Math.ceil(totalCount / perPage));
    }, [totalCount, perPage]);

    return (
        <div className="pagination-block">
            <Pagination
                count={pageCount}
                page={page}
                onChange={handlePageChange}
                variant="outlined"
                showFirstButton={showFirstButton}
                showLastButton={showLastButton}
                hidePrevButton={hidePrevButton}
                hideNextButton={hideNextButton}
                siblingCount={siblingCount}
                boundaryCount={boundaryCount}
            />
            <div className="pagination-block-per-page">
                <SelectionFilterT
                    list={perPageList.map(item => ({ label: item.toString(), value: item }))}
                    selectedItem={{ label: perPage.toString(), value: perPage }}
                    setSelectedItem={item => setPerPage(item.value)}
                    rightPosition={true}
                />
            </div>
        </div>
    );
};
